/**
 * Concorsando API
 * API per Concorsando
 *
 * OpenAPI spec version: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class Sorgente.
* @enum {}
* @readonly
*/
export default class Sorgente {
        /**
         * value: "MOBILE"
         * @const
         */
        MOBILE = "MOBILE";

        /**
         * value: "WEB"
         * @const
         */
        WEB = "WEB";


    /**
    * Returns a <code>Sorgente</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/Sorgente} The enum <code>Sorgente</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}
